import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { Router,ActivatedRoute } from '@angular/router';
import {Data} from './data';

@Component({
    selector: 'app-couponcode',
    templateUrl: './branchcompany.component.html',
  providers: [ SharedService,PopupSegmentComponent]
 
})
export class BranchCompanyComponent implements OnInit {

data=[];
companyArray=[];
i=1;
searchBranchText = '';
page : number =1;
name ="";
itemsTotalAdv : number =0;
enable = [];
objLoaderStatus: boolean = false;
blockedFlag : boolean = false;
message = '';
errormessage = '';
charFlag :boolean = false;
userId : number;
searchmessage = "";
id: number;
companyName = "";
companies = [];
disabledCheckValue =[];
companiesSelected = [];
companySelected = {"id":'',"name":''};
coupon =[];
branches=[];
user = [];
radioselected : any;

    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
    private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService,
    private router: Router,private route: ActivatedRoute,
    private dataCompany: Data) {

    
    }

    ngOnInit() {
      var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
       this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
this.localstorage.setStorage("country",'');

       var i=0;
         var token = this.localstorage.getStorage("token");
        // this.loaderService.displayLoader(true);
  // this.shareService.CallDatawithToken("admin/getAllAdvertiser?currentSize=5", null, token).subscribe((result) => {
 this.route.params.subscribe(params => {
    this.name = params['name'];
    console.log(this.name);
});

  //    });
  if(this.dataCompany.storage && this.dataCompany.storage.user){
this.companySelected= this.dataCompany.storage.user;
 }
 if(this.dataCompany.storage && this.dataCompany.storage.companies){
this.companies= this.dataCompany.storage.companies;
 }
 if(this.dataCompany.storage && this.dataCompany.storage.branches){
this.branches= this.dataCompany.storage.branches;
 }

 if(this.dataCompany.storage && this.dataCompany.storage.coupon){
this.coupon= this.dataCompany.storage.coupon;
 }

 if(this.dataCompany.storage && this.dataCompany.storage.companiesSelected){
this.companiesSelected = this.dataCompany.storage.companiesSelected;
 }

 if(this.dataCompany.storage && this.dataCompany.storage.radioselected == false){
this.radioselected = this.dataCompany.storage.radioselected;
 }

  var token = this.localstorage.getStorage("token");
         this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/searchAdvertisersByCompanyName?q="+this.name+"&currentSize=10&currentPage=1", null, token).subscribe((result) => {
 console.log(result.data)
if(result.data && result.data.length>0){
    this.data = result.data;
 this.dataModulation();
       this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
}
else{

}
  this.loaderService.displayLoader(false);

     });
    }

dataModulation(){
  var i=0;
  var j=0;
    for(i=0;i<this.data.length;i++){
  for(j=0;j<this.branches.length;j++){
if(this.data[i].userId == this.branches[j]){
  this.disabledCheckValue[this.data[i].userId ] = true;
}
  }
    }
}

nextBranch(event){
    var j=0;
    this.page = event;
         var token = this.localstorage.getStorage("token");
 this.searchBranchText = this.searchBranchText.trim();
    this.itemsTotalAdv =0;
  this.data =[];
   var i=0;
            this.errormessage ="";
this.searchmessage ="";
      if(this.searchBranchText =='' || this.searchBranchText == undefined){
          this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("admin/searchAdvertisersByCompanyName?q="+this.name+"&currentPage="+event+"&currentSize=10", null, token).subscribe((result) => {
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;
    this.dataModulation();
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
      }
       else{
        this.searchmessage = "No records found";
      }
    this.loaderService.displayLoader(false);

}
  
         });
    } 
    else{
       if(this.searchBranchText.length<2){
this.errormessage = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
                   this.loaderService.displayLoader(true);
      this.shareService.CallDatawithToken("master/searchBranchByCompanyIdAndBranchName?currentPage="+event+"&currentSize=10&companyId="+this.companySelected.id+"&q="+this.searchBranchText, null, token).subscribe((result) => {
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;

this.dataModulation();
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    }
     else{
        this.searchmessage = "No records found";
      }
              this.loaderService.displayLoader(false);

    }
         });
    }
    }
    return event; 
    
        
}

changeSelect(id,e){
  var i=0;
   // var user = {"id":'',"name":''};

  for(i=0;i<this.data.length;i++){
if(this.data[i].userId == id){
  this.disabledCheckValue[id] = e.target.checked;
  if(e.target.checked == true){
  this.branches.push(this.data[i].userId);
}
else{
  var index= this.branches.indexOf(this.data[i].userId);
  this.branches.splice(index,1);
}

}


  }

// if(this.branches.length>0){
//   this.companiesSelected.push(this.companySelected.id);
// }
  return e;
}

allBranch(){
    this.page = 1;

    var token = this.localstorage.getStorage("token");
  this.searchBranchText = '';
        this.itemsTotalAdv = 0;
 this.errormessage ="";
this.searchmessage ="";
   this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/searchAdvertisersByCompanyName?q="+this.name, null, token).subscribe((result) => {
   if(result.data){
    this.data = result.data;
 this.dataModulation();
       this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
  this.loaderService.displayLoader(false);
}
         });
}
   searchBranch(searchBranchText){
     this.itemsTotalAdv =0;
       this.data =[];
              this.page =1;

      var token = this.localstorage.getStorage("token");
        //this.id = id;
         this.errormessage ="";
         this.searchmessage ="";
this.searchBranchText = this.searchBranchText.trim();
if(searchBranchText.length == 0){
this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("admin/searchAdvertisersByCompanyName?q="+this.name, null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
     this.loaderService.displayLoader(false);
  this.dataModulation();
    }
         });
}
       else if(searchBranchText.length<2){
this.errormessage = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
         this.loaderService.displayLoader(true);
      
 this.shareService.CallDatawithToken("master/searchBranchByCompanyIdAndBranchName?currentPage=1&currentSize=10&companyId="+this.companySelected.id+"&q="+searchBranchText, null, token).subscribe((result) => {
    console.log(result.data);

    if(result.data){
       if(result.data.length>0){
    this.data = result.data;
    this.dataModulation();
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    }
     else{
        this.searchmessage = "No records found";
      }
        this.loaderService.displayLoader(false);
  }
  
         });
   }
       
}

selectBranches(){
 

   this.dataCompany.storage = {
    "companies": this.companies,
    "coupon": this.coupon,
  "branches": this.branches,
  "companySelected":this.companiesSelected,
  "selected": this.companySelected,
    "radioselected" : this.radioselected

  }

     this.router.navigate(['/admin/couponCodes/audience']);
} 

   

}



// WEBPACK FOOTER //
// ./src/app/admin/layout/couponCode/branchcompany.component.ts